export class Animation {


    /**
     * Donation progress bar animations - animate goal, added users and line length
     */
    static donationProgressBar()
    {
        jQuery(function ($) {
            var animated = false;
            var $petitionBox = $('.petition-box');

            if ($petitionBox.length && animated === false && Animation.isScrolledIntoView($petitionBox.get(0))) {
                Animation.handleDonationProgressBar();
                animated = true;
            }

            $(window).scroll(function () {
                if ($petitionBox.length && animated === false && Animation.isScrolledIntoView($petitionBox.get(0))) {
                    Animation.handleDonationProgressBar();
                    animated = true;
                }
            });

        });
    }

    /**
     * Animate numbers, line lengths in progress bar stats
     */
    static progressStats()
    {
        var $ = jQuery;

        // Animate numbers
        $('.progress-stats-list li').each(function() {
            var $item = $(this);
            var $counter = $item.find('*[data-count]');

            if($counter.length == 0) {
                return;
            }

            Animation.animateElementNumber($counter);
        })

        // Animate numbers
        $('.js-animate-number').each(function() {
            var $item = $(this);
            var $counter = $item;

            if($counter.length == 0) {
                return;
            }

            Animation.animateElementNumber($counter)
        })

        // Animate front line text
        $('.js-front-line-text').each(function() {
            var $item = $(this);

            Animation.animateElementNumber($item);
        })

        // Animate progress bar
        $('.js-front-line').each(function() {
            var $item = $(this);

            Animation.animateElementLine($item);
        })

    }

    /**
     * @param $element
     */
    static animateElementLine($element)
    {
        var $ = jQuery;
        var $this = $element,
            countTo = $this.attr('data-count').replace(/\s/g, '');

        $({countNum: $this.text().replace(/\s/g, '')}).animate({
                countNum: countTo
            },
            {
                duration: 2000,
                easing: 'linear',
                step: function () {
                    $this.css("left", parseFloat(this.countNum) + '%');
                },
                complete: function () {
                    $this.css("left", parseFloat(this.countNum) + '%');
                }
            });
    }


    /**
     * @param $element
     */
    static animateElementNumber($element)
    {
        var $ = jQuery;
        var $this = $element,
            countTo = $this.attr('data-count').replace(/\s/g, '');

        $({countNum: $this.text().replace(/\s/g, '')}).animate({
                countNum: countTo
            },
            {
                duration: 2000,
                easing: 'linear',
                step: function () {
                    $this.text(Math.floor(this.countNum).toLocaleString('fr-FR'));
                },
                complete: function () {
                    $this.text(parseFloat(this.countNum).toLocaleString('fr-FR'));
                }
            });
    }

    static progressLine()
    {
        var $ = jQuery;
        // Animate line length
        $('.js-progress-line').each(function () {
            // Animate line length
            var $this = $(this);
            Animation.animateProgressLine($this);
        });
    }

    static handleDonationProgressBar()
    {
        var $ = jQuery;
        // Animate counts
        $('.js-progress-count').each(function () {
            var $this = $(this);
            Animation.animateDonationProgressCount($this);
        });
    }

    /**
     * @param {jQuery} element
     */
    static animateDonationProgressCount($element)
    {
        var $ = jQuery;
        var $this = $element;
        var countTo = $element.attr('data-count').replace(/\s/g, '');

        $({countNum: $this.text().replace(/\s/g, '')}).animate({
                countNum: countTo
            },
            {
                duration: 2000,
                easing: 'linear',
                step: function () {
                    $this.text(Math.floor(this.countNum).toLocaleString('fr-FR'));
                },
                complete: function () {
                    $this.text(this.countNum.toLocaleString('fr-FR'));
                }
            });
    }

    /**
     * @param {jQuery} $line
     */
    static animateProgressLine($line)
    {
        var $ = jQuery;
        //
        // Animate line length
        var width = parseFloat($line.attr('data-line'));
        var text = width;

        if(width < 15) {
            width = 15;
        }

        var left = width;
        var $text = $line.parent().find('.text');

        if($line.parent('.progress-bar')) {
            left = left > 88 ? 88 : left;
        }

        //
        $line.width(width + '%');
        // Text
        $text.text(Math.floor(text) + '%');
        $text.css({
            'left': left + '%'
        });
    }

    /**
     * @param {jQuery} $bar
     */
    static animatePetitionProgressBar($bar)
    {
        var $ = jQuery;

        // Animate line
        $bar.find('.js-progress-line').each(function () {
            // Animate line length
            var $this = $(this);
            Animation.animateProgressLine($this);
        });
        // Animate count
        $bar.find('.js-progress-count').each(function () {
            var $this = $(this);
            Animation.animateDonationProgressCount($this);
        });
    }

    /**
     * @param {jQuery} $element
     */
    static animateDonationProgressBar($element)
    {
        var $ = jQuery;

        // Animate line
        $element.find('.js-progress-line').each(function () {
            // Animate line length
            var $this = $(this);
            Animation.animateProgressLine($this);
        });
        // Animate count
        Animation.progressStats();
    }

    /**
     * @param {jQuery} $bar
     */
    static animateSocialProgressEmailBar($bar)
    {
        var $ = jQuery;

        // Animate line
        $bar.find('.js-progress-line').each(function () {
            // Animate line length
            var $this = $(this);
            Animation.animateProgressLine($this);
        });
        // Animate count
        $bar.find('.js-progress-count').each(function (index, item) {
            var $element = $(item);
            //
            Animation.animateDonationProgressCount($element);
        });
    }

    /**
     * @param {Element} element
     * @return {boolean}
     */
    static isScrolledIntoView(element)
    {
        // Get the elements position relative to the viewport
        var bb = element.getBoundingClientRect();

        // Check if the element is outside the viewport
        // Then invert the returned value because you want to know the opposite
        return !(bb.top > window.innerHeight || bb.bottom < 0);
    }
}